import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=1e2ee25a&scoped=true&"
import script from "./Payment.vue?vue&type=script&lang=ts&"
export * from "./Payment.vue?vue&type=script&lang=ts&"
import style0 from "./Payment.vue?vue&type=style&index=0&id=1e2ee25a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2ee25a",
  null
  
)

export default component.exports